var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowTos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-Backtest---Intraday",
    transform: "translate(-29.000000, -204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(27.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25,2.75 C18.3545695,2.75 19.25,3.6454305 19.25,4.75 L19.25,17.25 C19.25,18.3545695 18.3545695,19.25 17.25,19.25 L8.41666667,19.25 C7.31209717,19.25 6.41666667,18.3545695 6.41666667,17.25 L6.41666667,4.75 C6.41666667,3.6454305 7.31209717,2.75 8.41666667,2.75 L17.25,2.75 Z M13.134,14.575 L12.38875,14.575 C12.0849934,14.575 11.83875,14.8212434 11.83875,15.125 L11.83875,15.125 L11.83875,15.87025 C11.83875,16.1740066 12.0849934,16.42025 12.38875,16.42025 L12.38875,16.42025 L13.134,16.42025 C13.4377566,16.42025 13.684,16.1740066 13.684,15.87025 L13.684,15.87025 L13.684,15.125 C13.684,14.8212434 13.4377566,14.575 13.134,14.575 L13.134,14.575 Z M13.298952,5.54060232 C11.3948826,5.26331065 9.71264645,6.43717871 9.20427839,8.11941482 C9.03790339,8.65551204 9.44459783,9.20085232 10.0084242,9.20085232 L10.0084242,9.20085232 L10.1932853,9.20085232 L10.3046549,9.19299572 C10.6314986,9.14641072 10.8902117,8.89768009 11.0066742,8.58156759 C11.302452,7.75893565 12.1805423,7.19510926 13.132577,7.39845648 C14.0106673,7.58331759 14.6576812,8.44292176 14.5837367,9.33949815 C14.4913062,10.5780676 13.0863617,10.8461162 12.3191881,12.0014982 C12.3191881,12.0107412 12.3099451,12.0107412 12.3099451,12.0199843 C12.300702,12.0384704 12.2914589,12.0477134 12.2822159,12.0661995 C12.1990284,12.2048454 12.1158409,12.3619773 12.0511395,12.5283523 C12.0418964,12.5560815 12.0234103,12.5745676 12.0141673,12.6022968 C12.0049242,12.6207829 12.0049242,12.639269 11.9956812,12.6669982 C11.8847645,12.981262 11.8108201,13.3602273 11.8108201,13.8223801 L11.8108201,13.8223801 L13.6594312,13.8223801 L13.66769,13.6335821 C13.6948629,13.3276199 13.7872934,13.0644495 13.9182367,12.8333732 C13.9367228,12.805644 13.9459659,12.7779148 13.964452,12.7501857 C14.0383964,12.6207829 14.130827,12.5006232 14.2232576,12.3897065 C14.2325006,12.3804634 14.2417437,12.3619773 14.2509867,12.3527343 C14.3434173,12.2418176 14.4450909,12.140144 14.5560076,12.0384704 C15.4433409,11.1973523 16.6449381,10.5133662 16.3953756,8.74794259 C16.1735423,7.13965093 14.9072437,5.78092176 13.298952,5.54060232 Z",
    id: "Combined-Shape",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3F3F",
    x: 2.75,
    y: 3.66666667,
    width: 1.83333333,
    height: 14.6666667,
    rx: 0.916666667
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowTos);
export default __webpack_public_path__ + "static/media/how-tos.6dbc4a7662fc6b5bd75b4ba0343711d5.svg";
export { ForwardRef as ReactComponent };